var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5195 39.52C38.3405 40.6186 37.3949 41.9434 36.739 43.4154C36.0832 44.8874 35.7305 46.4764 35.7021 48.0877C35.6736 49.6989 35.97 51.2994 36.5736 52.7936C37.1771 54.2878 38.0754 55.6451 39.2149 56.7846C40.3544 57.9241 41.7118 58.8224 43.206 59.426C44.7002 60.0295 46.3006 60.3259 47.9119 60.2975C49.5231 60.2691 51.1121 59.9164 52.5841 59.2605C54.0561 58.6046 55.3809 57.659 56.4795 56.48",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9199 20.32C44.6052 20.11 46.3017 20.0032 47.9999 20C75.9999 20 87.9999 48 87.9999 48C86.2116 51.8285 83.9688 55.4277 81.3199 58.72",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 26.4399C18.485 31.8584 12.1195 39.301 8 47.9999C8 47.9999 20 75.9999 48 75.9999C55.6636 76.0205 63.1631 73.7804 69.56 69.5599",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L88 88",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEyeOff;